var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.icon)?_c('div',{staticClass:"squared-icon__wrap",style:(_vm.iconStyles)},[_c('unicon',{staticClass:"squared-icon__icon",attrs:{"width":"20","height":"20","name":_vm.icon,"fill":_vm.styles.themePrimary}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }